module.exports = __webpack_public_path__ + "static/media/undraw_answer.677a27b0.svg";